import React, { useCallback } from 'react'
import { getSectionTheme } from '@v4/utils/theme'
import AppThemeProvider from '@v4/components/common/AppThemeProvider'

const withPrimaryColor = WrappedComponent => ({ primaryColor, ...restProps }) => {
	const theme = useCallback(
		parentTheme =>
			getSectionTheme(parentTheme, {
				palette: {
					primary: primaryColor,
				},
			}),
		[primaryColor],
	)

	if (primaryColor && primaryColor !== 'inherit') {
		return (
			<AppThemeProvider theme={theme}>
				<WrappedComponent {...restProps} />
			</AppThemeProvider>
		)
	}

	return <WrappedComponent {...restProps} />
}

export default withPrimaryColor
